import md5             from 'md5';


const BPTracking = function() {
	const omniPagenameDefault = window.location.href.split("://")[1].split("?")[0].split("#")[0].replace('www.',''),
				pamProductName = 'brandplay',
				omnitureEnable = true;

	let sfNumObj = {};

	if($('meta[data-ipp]').length > 0) {
		sfNumObj = $('meta[data-ipp]').data();
	}

	this.omni = function (sLink, pName, obj) { // Omniture Ad Hoc tracking, for Internal or External-Domain destinations
		try {
			var self = this;
			if (typeof pName == 'object')
			{
				obj = pName;
				pName = undefined;
			}
			if (omnitureEnable) {
				if (typeof obj != 'undefined' && typeof obj == 'object') {

					if (typeof obj.href != 'undefined') { // if referring element link points to external domain, fire external Omniture function
						if ((obj.href.match(/:\/\//) != null && obj.href.match(/:\/\/[^\/]+\//)[0].split('/')[2] != document.domain) || $.trim(obj.href) == window.location.href.split('#')[0] + "#") {
							self.omniPageLink(sLink, pName);
						}
						else { // else fire internal Omniture function
							self.omniTrack(sLink, pName);
						}
					}
					else if (typeof obj.action != 'undefined') { // if referring element form action points to external domain, fire external Omniture function
						if ((obj.action.match(/:\/\//) != null && obj.action.match(/:\/\/[^\/]+\//)[0].split('/')[2] != document.domain) || $.trim(obj.action) == window.location.href.split('#')[0] + "#") {
							self.omniPageLink(sLink, pName);
						}
						else { // else fire internal Omniture function
							self.omniTrack(sLink, pName);
						}
					}
					else {
						self.omniPageLink(sLink, pName);
					}
				}
				else {
					self.omniPageLink(sLink, pName);
				}
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	this.omniTrack = function (sLink, pName) { // Omniture Ad Hoc tracking, for In-Domain destinations
		try {
			if (omnitureEnable) {
				if (typeof pName == 'object')
				{
					pName = undefined;
				}
				if (typeof wmdTrack != 'undefined') {
						if (typeof pName != 'undefined')
						{
							s_md.pageName = pName;
						}
						wmdTrack(sLink);
						if (typeof pName != 'undefined') {
							s_md.pageName = omniPagenameDefault;
						}
				}
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	this.omniPageLink = function (sLink, pName) { // Omniture Ad Hoc tracking, for External-Domain destinations
		try {
			if (omnitureEnable) {
				if (typeof pName == 'object')
				{
					pName = undefined;
				}
				if (typeof wmdPageLink != 'undefined') {
						if (typeof pName != 'undefined')
						{
							s_md.pageName = pName;
						}
						wmdPageLink(sLink);
						if (typeof pName != 'undefined') {
							s_md.pageName = omniPagenameDefault;
						}
				}
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	this.omniPageview = function (pCount, pName) { // Omniture Page View function
		try {
			if (omnitureEnable) {
				if (typeof pName == 'object')
				{
					pName = undefined;
				}
				if (typeof wmdPageview != 'undefined') {
					if (typeof pName != 'undefined') {
							wmdPageview(pName, pCount);
					}
					else {
							wmdPageview("", pCount);
					}
					if (typeof pName != 'undefined') {
						s_md.pageName = omniPagenameDefault;
					}
				}
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	this.pamTrack = function (assetName, moduleStrOrPvNum, element) {  //Function to Send Track, or Bind to Elements
		try {
			//addLinkTrackVars('contextData.wb.spcrtid');
			var self = this;
			if (typeof element == 'object') {
				if (typeof moduleStrOrPvNum == 'number'){
					this.omniPageview(moduleStrOrPvNum, document.domain.replace('wp.','').replace(/www\.(.+\.com)/,'$1') + '/' + pamProductName + '/' + sfNumObj.ipp.sfNum + '/' + md5(sfNumObj.ipp.sfNum + '_' + assetName) + '/', element);
				}
				else {
					this.omni(moduleStrOrPvNum, document.domain.replace('wp.','').replace(/www\.(.+\.com)/,'$1') + '/' + pamProductName + '/' + sfNumObj.ipp.sfNum + '/' + md5(sfNumObj.ipp.sfNum + '_' + assetName) + '/', element);
				}
			}
			else {
				if (typeof moduleStrOrPvNum == 'number'){
					this.omniPageview(moduleStrOrPvNum, document.domain.replace('wp.','').replace(/www\.(.+\.com)/,'$1') + '/' + pamProductName + '/' + sfNumObj.ipp.sfNum + '/' + md5(sfNumObj.ipp.sfNum + '_' + assetName) + '/');
				}
				else {
					this.omni(moduleStrOrPvNum, document.domain.replace('wp.','').replace(/www\.(.+\.com)/,'$1') + '/' + pamProductName + '/' + sfNumObj.ipp.sfNum + '/' + md5(sfNumObj.ipp.sfNum + '_' + assetName) + '/');
				}
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	this.trackIpp = function(action) {
		try {
			var self = this;
			if (typeof sfNumObj.ipp.wpUrl != 'undefined' && typeof sfNumObj.ipp.parIdE != 'undefined' && typeof sfNumObj.ipp.activityId != 'undefined')
			{
				var preload_image = new Image(1,1);
				if (typeof sfNumObj.ipp.tacticId != 'undefined')
				{
					preload_image.src = '//' + sfNumObj.ipp.wpUrl + '/activity/viewpresentation?action=' + action + '&activityId=' + sfNumObj.ipp.activityId + '&parId=' + sfNumObj.ipp.parIdE + '&tacticId=' +  sfNumObj.ipp.tacticId;
				}
				else
				{
					preload_image.src = '//' + sfNumObj.ipp.wpUrl + '/activity/viewpresentation?action=' + action + '&activityId=' + sfNumObj.ipp.activityId + '&parId=' + sfNumObj.ipp.parIdE;
				}
			}
		} catch(err) {
			console.log(err);
		}
	};

	this.thirdPartyTracking = function(url, assetName, moduleStrOrPvNum){ // creates an <img> with the src attribute of a 3rd party and appends it to the bottom of the body
		url = url + '?' + assetName + '=' + moduleStrOrPvNum;
        let img = document.createElement('img');
        img.src = url;
        $(img).css({
			position: 'absolute',
			display: 'none',
			bottom: 0
		});
        $('body').append(img);
	};
};

export default BPTracking;



// WEBPACK FOOTER //
// ./modules/mixins/bp_tracking.js